{
  "customer-form-dialog": {
    "field": {
      "last_checkin": "Last checkin",
      "number_of_visit": "Number of visit",
      "registered_since": "Registered since",
      "type": "Type"
    },
    "button": {
      "cancel": "Cancel",
      "submit": "Submit"
    },
    "text": {
      "create_customer": "Create new customer profile",
      "create_customer_success": "Successfully created",
      "edit_customer": "Edit customer profile",
      "edit_customer_success": "Successfully updated"
    }
  }
}
